import { useUncontrolled } from "@/hooks/useUncontrolled";
import { styled } from "@monolith-forensics/monolith-ui";
import React from "react";

export const TabPanel = styled.div<{
  value: string;
}>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

TabPanel.displayName = "TabPanel";

const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;

  .tabs-list {
    user-select: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    color: ${({ theme }) => theme.palette.text.secondary};
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  }

  .tab {
    padding-right: 10px;
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid transparent;
  }

  .tab:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }

  .tab[data-active="true"] {
    border-bottom-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.primary.main};
  }

  .tab-content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: 0px;
  }
`;

export const FlyoutTabs: React.FC<{
  children: React.ReactNode[];
  tabDefs: { label: string; value: string }[];
  defaultValue?: string;
  value?: string;
  onChange?: () => void;
}> = ({ children, tabDefs, defaultValue, value, onChange }) => {
  const [_value, handleChange] = useUncontrolled({
    value,
    defaultValue,
    finalValue: "details",
    onChange,
  });

  const activePanel = React.Children.toArray(children).find(
    (child: any) => child.props.value === _value
  );

  return (
    <TabsContainer>
      <div className="tabs-list">
        {tabDefs.map((tab) => (
          <div
            className={`tab`}
            data-active={_value === tab.value}
            onClick={() => handleChange(tab.value)}
            key={tab.value}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div className="tab-content">{activePanel}</div>
    </TabsContainer>
  );
};
